import React, { useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import {
    StoreType,
    ChangeUserSettings,
    updateUserSettings,
} from "client/store"
import {
    PageForm,
    FormGroup,
    Label,
    LabelValue,
    Input,
    Collapse,
} from "client/components"

import FormatPercentage from "client/pages/sil/format/percentage"
import { customParseInt, customParseFloat } from "client/pages/sil/format/parse"


const Iec615081998 = () => {
    const settings = useSelector((state: StoreType) => state.userSettings.settings.sil)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [show, setShow] = useState(false)

    const onChange = (value: ChangeUserSettings) => {
        dispatch(updateUserSettings("sil", value))
    }

    const { iec615081998 } = settings
    const {
        t1,
        mttr,
        beta,
    } = iec615081998

    return (
        <Collapse
            show={show}
            title={lang.defaultIec_61508_1998_settings}
            onCollapse={() => setShow(!show)}
        >
            <PageForm>
                <FormGroup>
                    <Label>
                        {lang.defaultT1}
                        <LabelValue>{lang.hoursLabel}</LabelValue>
                    </Label>
                    <Input
                        type="text"
                        value={t1}
                        onChange={(e) => onChange({
                            iec615081998: {
                                ...iec615081998,
                                t1: e.target.value,
                            },
                        })}
                        onBlur={(e) => onChange({
                            iec615081998: {
                                ...iec615081998,
                                t1: customParseInt(e.target.value),
                            },
                        })}
                    />
                </FormGroup>
                <FormGroup>
                    <Label>
                        {lang.defaultMttr}
                        <LabelValue>{lang.hoursLabel}</LabelValue>
                    </Label>
                    <Input
                        type="text"
                        value={mttr}
                        onChange={(e) => onChange({
                            iec615081998: {
                                ...iec615081998,
                                mttr: e.target.value,
                            },
                        })}
                        onBlur={(e) => onChange({
                            iec615081998: {
                                ...iec615081998,
                                mttr: customParseInt(e.target.value),
                            },
                        })}
                    />
                </FormGroup>

                <FormatPercentage
                    title={lang.defaultBeta}
                    data={beta}
                    onChange={(value) => onChange({
                        iec615081998: {
                            ...iec615081998,
                            beta: customParseFloat(value),
                        },
                    })}
                />
            </PageForm>
        </Collapse>
    )
}
export default Iec615081998
